import React from 'react';
import { RHFTextField } from '@talentmesh/forms';
import Constants from '../Constants';
import ApplicantInformationType from '../../../../../../Models/ApplicantInformationType';
import useTMTranslation from '../../../../../../Hooks/useTMTranslation';

function StructureImportance(): React.JSX.Element {
    const { tCommon: t } = useTMTranslation();

    return (
        <RHFTextField
            multiline
            fullWidth
            label={`${t('HowImportantAreStructureAndProcesses')}*`}
            name={ApplicantInformationType.StructureImportance}
            rows={Constants.numberOfRows}
            maxChar={Constants.textFieldLargeCapacity}
        />
    );
}

export default StructureImportance;
